import React from "react";
import { Link } from "react-router";

import { Button, Divider } from "../Controls";

import "../../assets/styles/styles.less";
import "./styles.less";
import PledgeImage from "../../assets/images/2018/landing/Pledge_10.png";
import Step2Image from "../../assets/images/2018/landing/Step 2.png";
import Step3Image from "../../assets/images/2018/landing/Step 3.png";
import texts from "../../assets/strings/home";

const HomeDesktop = () => (
  <div className="home desktop">
    <div className="flex-column flex-center grid-100 area1">
      <div className="flex-column flex-center grid-100">
        <h2>{texts.area1.h2}</h2>
        <h3>{texts.area1.h3}</h3>
      </div>
    </div>
    <h2 className="mainTitle">{texts.area2.title}</h2>
    <div className="flex-column flex-center grid-100 area2 bordered">
      <div className="flex-column flex-center grid-100">
        <img className="area-image" src={PledgeImage} />
      </div>
      <div className="flex-column flex-center grid-100">
        <h2 className="stepTitle">{texts.area2.step1.h1}</h2>
        <h3>{texts.area2.step1.h2}</h3>
      </div>
    </div>
    <div className="flex-column flex-center grid-100 area2 bordered reverse-row">
      <div className="flex-column flex-center grid-100">
        <img className="area-image" src={Step2Image} />
      </div>
      <div className="flex-column flex-center grid-100">
        <h2 className="stepTitle">{texts.area2.step2.h1}</h2>
        <h3>{texts.area2.step2.h2}</h3>
      </div>
    </div>
    <div className="flex-column flex-center grid-100 area2">
      <div className="flex-column flex-center grid-100">
        <img className="area-image" src={Step3Image} />
      </div>
      <div className="flex-column flex-center grid-100">
        <h2 className="stepTitle">{texts.area2.step3.h1}</h2>
        <h3>{texts.area2.step3.h2}</h3>
      </div>
    </div>
    <h3 className="areaTitle">Start by Doing Good</h3>
    <Link to="/proceed">
      <Button
        style={{ marginBottom: 40 }}
        label={texts.area1.buttonLabel}
        primary={true}
        large={true}
      />
    </Link>
  </div>
);
export default HomeDesktop;



// WEBPACK FOOTER //
// ./components/Home/HomeDesktop.js